import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = { class: "card-header border-0" }
const _hoisted_4 = { class: "card-title m-0" }
const _hoisted_5 = { class: "fw-bolder m-0" }
const _hoisted_6 = { class: "collapse show" }
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = { class: "px-7 py-5" }
const _hoisted_9 = { class: "d-flex align-items-center mb-5" }
const _hoisted_10 = { class: "fs-7 fw-semibold text-gray-600 text-uppercase ls-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-300 flex-grow-1 ms-3" }, null, -1)
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-3 col-6" }
const _hoisted_14 = { class: "form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-3 col-6" }
const _hoisted_16 = { class: "form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-3 col-6 mt-lg-0 mt-4" }
const _hoisted_18 = { class: "form-label fw-bold fs-6" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "col-lg-3 col-6 mt-lg-0 mt-4" }
const _hoisted_21 = { class: "form-label fw-bold fs-6" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = { class: "row mb-8" }
const _hoisted_24 = { class: "col-lg-3 col-6" }
const _hoisted_25 = { class: "form-label fw-bold fs-6" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { class: "col-lg-3 col-6" }
const _hoisted_28 = { class: "form-label fw-bold fs-6" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = { class: "d-flex align-items-center mb-5" }
const _hoisted_31 = { class: "fs-7 fw-semibold text-gray-600 text-uppercase ls-1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-300 flex-grow-1 ms-3" }, null, -1)
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = { class: "form-label fw-bold fs-6" }
const _hoisted_36 = { class: "col-6" }
const _hoisted_37 = { class: "form-label fw-bold fs-6" }
const _hoisted_38 = { class: "row mb-8" }
const _hoisted_39 = { class: "col-12" }
const _hoisted_40 = { class: "form-label fw-bold fs-6" }
const _hoisted_41 = { class: "d-flex align-items-center mb-5" }
const _hoisted_42 = { class: "fs-7 fw-semibold text-gray-600 text-uppercase ls-1" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-300 flex-grow-1 ms-3" }, null, -1)
const _hoisted_44 = { class: "row mb-4" }
const _hoisted_45 = { class: "col-6" }
const _hoisted_46 = { class: "form-label fw-bold fs-6" }
const _hoisted_47 = { class: "col-6" }
const _hoisted_48 = { class: "form-label fw-bold fs-6" }
const _hoisted_49 = {
  key: 0,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 1,
  class: "text-center py-10 text-muted fs-6"
}
const _hoisted_53 = { class: "card-footer d-flex justify-content-between align-items-center py-6 px-9" }
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = { class: "fw-bold fs-6 text-gray-700" }
const _hoisted_56 = { class: "d-flex" }
const _hoisted_57 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_58 = { class: "indicator-label" }
const _hoisted_59 = { class: "indicator-progress" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_61 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_62 = { class: "card-body text-center py-12" }
const _hoisted_63 = { class: "svg-icon svg-icon-3x svg-icon-gray-400 mb-4 d-block" }
const _hoisted_64 = { class: "fs-4 fw-semibold text-gray-500" }
const _hoisted_65 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_66 = { class: "card-header border-0 d-flex justify-content-between align-items-center" }
const _hoisted_67 = { class: "card-title m-0" }
const _hoisted_68 = { class: "fw-bolder m-0" }
const _hoisted_69 = { class: "fs-7 text-muted ms-2" }
const _hoisted_70 = { class: "card-toolbar" }
const _hoisted_71 = {
  type: "button",
  class: "btn btn-light-primary btn-sm"
}
const _hoisted_72 = { class: "svg-icon svg-icon-2" }
const _hoisted_73 = { class: "card-body p-0" }
const _hoisted_74 = {
  class: "table-responsive",
  style: {"max-height":"500px","overflow-y":"auto"}
}
const _hoisted_75 = { class: "table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 mb-0" }
const _hoisted_76 = {
  class: "bg-light",
  style: {"position":"sticky","top":"0","z-index":"1"}
}
const _hoisted_77 = { class: "fw-bolder text-muted fs-7" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("th", { class: "ps-4 min-w-40px" }, "#", -1)
const _hoisted_79 = { class: "min-w-100px" }
const _hoisted_80 = { class: "min-w-80px" }
const _hoisted_81 = { class: "min-w-100px" }
const _hoisted_82 = { class: "min-w-120px" }
const _hoisted_83 = { class: "min-w-100px" }
const _hoisted_84 = { class: "min-w-70px text-end" }
const _hoisted_85 = { class: "min-w-90px text-end" }
const _hoisted_86 = { class: "min-w-90px text-end" }
const _hoisted_87 = { class: "min-w-60px text-center" }
const _hoisted_88 = { class: "min-w-70px text-end" }
const _hoisted_89 = { class: "min-w-90px" }
const _hoisted_90 = { class: "min-w-100px" }
const _hoisted_91 = { class: "min-w-80px text-center" }
const _hoisted_92 = { class: "min-w-90px text-center" }
const _hoisted_93 = { class: "min-w-100px" }
const _hoisted_94 = { class: "min-w-100px pe-4" }
const _hoisted_95 = { class: "ps-4 text-gray-600" }
const _hoisted_96 = { class: "fw-semibold" }
const _hoisted_97 = { class: "text-end" }
const _hoisted_98 = { class: "text-end" }
const _hoisted_99 = { class: "text-end" }
const _hoisted_100 = { class: "text-center" }
const _hoisted_101 = { class: "text-end" }
const _hoisted_102 = { class: "text-center" }
const _hoisted_103 = { class: "text-center" }
const _hoisted_104 = { class: "pe-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_vue3_json_excel = _resolveComponent("vue3-json-excel")!

  return (_ctx.can('read', 'reports'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.translate('registeredTradesReports')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _withModifiers(_ctx.onSubmitCreate, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.translate('dateAndRangeFilters')), 1),
                      _hoisted_11
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.translate('From')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control form-control-sm form-control-solid",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.dateFrom) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.selectedItems.dateFrom]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate('To')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control form-control-sm form-control-solid",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems.dateTo) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.selectedItems.dateTo]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('priceFrom')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control form-control-sm form-control-solid",
                          placeholder: _ctx.translate('priceFrom'),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItems.priceFrom) = $event))
                        }, null, 8, _hoisted_19), [
                          [_vModelText, _ctx.selectedItems.priceFrom]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.translate('priceTo')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control form-control-sm form-control-solid",
                          placeholder: _ctx.translate('priceTo'),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedItems.priceTo) = $event))
                        }, null, 8, _hoisted_22), [
                          [_vModelText, _ctx.selectedItems.priceTo]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.translate('sizeFrom')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control form-control-sm form-control-solid",
                          placeholder: _ctx.translate('sizeFrom'),
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItems.sizeFrom) = $event))
                        }, null, 8, _hoisted_26), [
                          [_vModelText, _ctx.selectedItems.sizeFrom]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('sizeTo')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control form-control-sm form-control-solid",
                          placeholder: _ctx.translate('sizeTo'),
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedItems.sizeTo) = $event))
                        }, null, 8, _hoisted_29), [
                          [_vModelText, _ctx.selectedItems.sizeTo]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.translate('propertyFilters')), 1),
                      _hoisted_32
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.translate('selectpropertyStatus')), 1),
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.propertyCategoryValues,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedItems.propertyCategoryValues) = $event)),
                          mode: "tags",
                          label: "description_ar",
                          trackBy: "description_ar",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.registeredTradesDesc,
                          placeholder: _ctx.translate('selectpropertyStatus'),
                          valueProp: "description_ar",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.translate('selectPropertyType')), 1),
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.propertyTypeIds,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedItems.propertyTypeIds) = $event)),
                          mode: "tags",
                          label: "title",
                          trackBy: "title",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.propertyTypes,
                          placeholder: _ctx.translate('selectPropertyType'),
                          valueProp: "id",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.translate('selectAreas')), 1),
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.areaIds,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedItems.areaIds) = $event)),
                          mode: "tags",
                          label: "title",
                          trackBy: "title",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.areas,
                          placeholder: _ctx.translate('selectAreas'),
                          valueProp: "id",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.translate('statusFilters')), 1),
                      _hoisted_43
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.translate('selectStatus')), 1),
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.statusIds,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedItems.statusIds) = $event)),
                          mode: "tags",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.statusOptions,
                          placeholder: _ctx.translate('selectStatus'),
                          valueProp: "value",
                          label: "label",
                          trackBy: "label",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.translate('statusNotes')), 1),
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.statusNotesIds,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedItems.statusNotesIds) = $event)),
                          mode: "tags",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.statusNotesOptions,
                          placeholder: _ctx.translate('selectStatusNotes'),
                          valueProp: "value",
                          label: "label",
                          trackBy: "label",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ])
                    ]),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
                      : _createCommentVNode("", true),
                    (_ctx.hasQueried && !_ctx.isLoading && (!_ctx.data || !_ctx.data.data || _ctx.data.data.length === 0))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.translate('noDataFound')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.translate('NumOfRegisteredTrades') +
                  (_ctx.showExportBtn && _ctx.data ? _ctx.data.data.length : 0)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light-danger btn-sm me-3",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
                    }, _toDisplayString(_ctx.translate('resetFilters')), 1),
                    _createElementVNode("button", {
                      type: "reset",
                      class: "btn btn-white btn-active-light-primary me-2",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                    }, _toDisplayString(_ctx.translate('back')), 1),
                    _createElementVNode("button", _hoisted_57, [
                      _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.translate('query')), 1),
                      _createElementVNode("span", _hoisted_59, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_60
                      ])
                    ], 512)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ])
        ]),
        (_ctx.hasQueried && (!_ctx.data || !_ctx.data.data || _ctx.data.data.length === 0))
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("span", _hoisted_63, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.translate('noResultsFound')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showExportBtn && _ctx.data && _ctx.data.data && _ctx.data.data.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("h3", _hoisted_68, [
                    _createTextVNode(_toDisplayString(_ctx.translate('resultsPreview')) + " ", 1),
                    _createElementVNode("span", _hoisted_69, [
                      (_ctx.data.data.length > _ctx.previewLimit)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" (" + _toDisplayString(_ctx.previewLimit) + " / " + _toDisplayString(_ctx.data.data.length) + ") ", 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" (" + _toDisplayString(_ctx.data.data.length) + ") ", 1)
                          ], 64))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createVNode(_component_vue3_json_excel, {
                    "json-data": _ctx.data.data,
                    fields: _ctx.excelHeader,
                    header: _ctx.excelHeaderRows,
                    worksheet: "Registered Trades WorkSheet",
                    name: 
              'Registered_Trades_Reports_' +
              new Date().toISOString().slice(0, 10) +
              '.xls'
            
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_71, [
                        _createElementVNode("span", _hoisted_72, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil017.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.translate('export')), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["json-data", "fields", "header", "name"])
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("table", _hoisted_75, [
                    _createElementVNode("thead", _hoisted_76, [
                      _createElementVNode("tr", _hoisted_77, [
                        _hoisted_78,
                        _createElementVNode("th", _hoisted_79, _toDisplayString(_ctx.translate('transactionNumber')), 1),
                        _createElementVNode("th", _hoisted_80, _toDisplayString(_ctx.translate('governorate')), 1),
                        _createElementVNode("th", _hoisted_81, _toDisplayString(_ctx.translate('area')), 1),
                        _createElementVNode("th", _hoisted_82, _toDisplayString(_ctx.translate('description')), 1),
                        _createElementVNode("th", _hoisted_83, _toDisplayString(_ctx.translate('propertyType')), 1),
                        _createElementVNode("th", _hoisted_84, _toDisplayString(_ctx.translate('size')), 1),
                        _createElementVNode("th", _hoisted_85, _toDisplayString(_ctx.translate('price')), 1),
                        _createElementVNode("th", _hoisted_86, _toDisplayString(_ctx.translate('pricePerM2')), 1),
                        _createElementVNode("th", _hoisted_87, _toDisplayString(_ctx.translate('block')), 1),
                        _createElementVNode("th", _hoisted_88, _toDisplayString(_ctx.translate('percentage')), 1),
                        _createElementVNode("th", _hoisted_89, _toDisplayString(_ctx.translate('status')), 1),
                        _createElementVNode("th", _hoisted_90, _toDisplayString(_ctx.translate('statusNotes')), 1),
                        _createElementVNode("th", _hoisted_91, _toDisplayString(_ctx.translate('blockCount')), 1),
                        _createElementVNode("th", _hoisted_92, _toDisplayString(_ctx.translate('isBlockTrade')), 1),
                        _createElementVNode("th", _hoisted_93, _toDisplayString(_ctx.translate('notes')), 1),
                        _createElementVNode("th", _hoisted_94, _toDisplayString(_ctx.translate('date')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewData, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_95, _toDisplayString(Number(index) + 1), 1),
                          _createElementVNode("td", _hoisted_96, _toDisplayString(item.transactionNumber), 1),
                          _createElementVNode("td", null, _toDisplayString(item.governorateName), 1),
                          _createElementVNode("td", null, _toDisplayString(item.areaName), 1),
                          _createElementVNode("td", null, _toDisplayString(item.descriptionAr), 1),
                          _createElementVNode("td", null, _toDisplayString(item.propertyTypeName), 1),
                          _createElementVNode("td", _hoisted_97, _toDisplayString(_ctx.formatNumber(item.size)), 1),
                          _createElementVNode("td", _hoisted_98, _toDisplayString(_ctx.formatNumber(item.price)), 1),
                          _createElementVNode("td", _hoisted_99, _toDisplayString(_ctx.formatNumber(item.pricePerM2)), 1),
                          _createElementVNode("td", _hoisted_100, _toDisplayString(item.block || '-'), 1),
                          _createElementVNode("td", _hoisted_101, _toDisplayString(item.percentage ? `${item.percentage}%` : '-'), 1),
                          _createElementVNode("td", null, _toDisplayString(item.statusName || '-'), 1),
                          _createElementVNode("td", null, _toDisplayString(item.statusNotesName || '-'), 1),
                          _createElementVNode("td", _hoisted_102, _toDisplayString(item.blockCount ?? '-'), 1),
                          _createElementVNode("td", _hoisted_103, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", 
                      item.isBlockTrade
                        ? 'badge-light-success'
                        : 'badge-light-danger'
                    ])
                            }, _toDisplayString(item.isBlockTrade
                        ? _ctx.translate('yes')
                        : _ctx.translate('no')), 3)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.notesAr || '-'), 1),
                          _createElementVNode("td", _hoisted_104, _toDisplayString(item.transactionDate
                      ? new Date(item.transactionDate)
                          .toISOString()
                          .slice(0, 10)
                      : '-'), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}